import React from 'react';
const date=value=>value&&Number.isFinite(Date.parse(value))?new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'short',year:'numeric',timeZone:'Europe/London'}).format(new Date(value)):'';
export default function FxNote({fx}){
 const q=fx?.quote;
 return <small className="rsi-pricing-note">{q?`USD → GBP ${q.value} · rate updated ${date(q.rateUpdatedAt)}. ${fx.status==='fresh'?'': 'Saved conversion; current rate pending. '}`:''}<a href="https://www.exchangerate-api.com" target="_blank" rel="noreferrer">Rates by ExchangeRate-API</a></small>;
}
